var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaptoreumLogoBw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 508 507.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fefefe;}.cls-2{fill:#121212;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.09,346C13,273.1-40.54,107.52,231.43,72.41c190.4-28.07,195.46-15.85,276.3-62.95-27.82,47.93-89.91,110.86-204,163.8C182.6,234.62,81.09,237.09,15.09,346Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.09,346c42.89-99,92-160.11,232.09-189.75C419.42,124.44,461,68.39,507.73,9.46c-27.82,47.93-89.91,112.3-204,165.25C182.6,236.06,81.09,237.09,15.09,346Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.66,265.73c14.3,63.11-32.93,118.72-115.54,89.83-3.47-1.44-3.47-2.6-2.31-5.63,14.58-37.7,51.7-75,111.35-85.79C196.34,263.27,198.94,262.84,199.66,265.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.38,244.19c-1.82,98.25-82,177.34-180.7,177.34a181.15,181.15,0,0,1-41.08-4.69A143.34,143.34,0,0,0,279.38,244.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272,220.77c55.78-27.91,87.34-43.24,117.85-63.43,24.7-16.55,86.67-61.57,117.85-57-40.71,19.19-90.81,79-123,96.87C351.69,215.13,325.89,220.77,272,220.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.64,495.15A141.4,141.4,0,0,1,51.38,412.2,141.86,141.86,0,0,1,15.61,354,142.14,142.14,0,0,0,24.69,498.8C24.66,497.59,24.64,496.37,24.64,495.15Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaptoreumLogoBw);
export default __webpack_public_path__ + "static/media/raptoreum-logo-bw.166a09fa5a0ec3abbc93628b85b70e4b.svg";
export { ForwardRef as ReactComponent };